import React from 'react';
import { motion } from 'framer-motion';
import { WHATSAPP_URL } from './constants';
type CtaVariant = 'primary' | 'secondary';
interface CtaButtonProps {
  variant?: CtaVariant;
  children: React.ReactNode;
  className?: string;
}
export function CtaButton({
  variant = 'primary',
  children,
  className = ''
}: CtaButtonProps) {
  const base = 'inline-flex items-center justify-center rounded-full px-7 py-3.5 text-base font-medium transition-all duration-300 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60';
  const styles = variant === 'primary' ? 'bg-white text-[#1B2B4A] hover:bg-white/90' : 'border border-white/70 text-white hover:bg-white/10';
  return <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className={`${base} ${styles} ${className}`} data-id="element-98">
      {children}
    </a>;
}
export function PricePill({
  className = ''
}: {
  className?: string;
}) {
  return <span className={`inline-flex items-center rounded-full border border-white/30 bg-white/10 px-5 py-2 text-sm font-medium text-white backdrop-blur-sm ${className}`} data-id="element-99">
      Sesión de 45 minutos · $10.000 ARS
    </span>;
}
interface FadeInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function FadeIn({
  children,
  className = '',
  delay = 0
}: FadeInProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-80px'
  }} transition={{
    duration: 0.7,
    ease: 'easeOut',
    delay
  }} className={className} data-id="element-100">
      {children}
    </motion.div>;
}